import { MODELS, useMultiModel } from "../../../../../api";
import Text from "../../../../../design-system/primitives/components/Text/Text";
import { ModuleLink } from "./ModuleLink";
import styles from "./StageSchedule.css";

interface StageScheduleProps {
  /** Optional on the workshop projection, so it is guarded like `stageSlug`. */
  sparkSlug: string | undefined;
  /** Absent when the selected phase has no stages at all — renders empty. */
  stageSlug: string | undefined;
  baseUrl: string;
  disableSome: boolean;
}

/**
 * Fetches and renders the module list for the selected stage. Suspends on every
 * stage change, so the caller keeps it behind its own <Suspense> — otherwise the
 * whole overview (title, navigation) unmounts while the fetch is in flight.
 */
export const StageSchedule = ({
  sparkSlug,
  stageSlug,
  baseUrl,
  disableSome,
}: StageScheduleProps) => {
  const [modules] = useMultiModel([
    sparkSlug && stageSlug
      ? MODELS.SPARK_SCHEDULE_STATIONS_AND_PROCEDURES(sparkSlug, stageSlug)
      : null,
  ]);

  return (
    <div className={styles.list} id="chapter-schedule">
      {!modules || modules.length === 0 ? (
        <div className={styles.emptyState}>
          <Text variant="body" color="neutral-100">
            Keine Module an diesen Tag
          </Text>
        </div>
      ) : (
        modules.map((module) => (
          <ModuleLink
            key={module.key}
            module={module}
            baseUrl={baseUrl}
            disableSome={disableSome}
          />
        ))
      )}
    </div>
  );
};
